import { useActiveDisplay } from "@/desktop/use-active-display";
import { findWorkToastKeyByAwaitingInputId, useWorkToastStore } from "@/stores/work-toast-store";

/** Opens the pill holding a question — used by the cursor "?" badge (Part 3).
 *  `displayId: null` (web, or a caller with no display of its own) resolves
 *  to the current cursor's active display rather than clearing it, so the
 *  card still opens on the right screen. `useActiveDisplay` is a plain
 *  zustand store with no Tauri calls at import time, so this stays
 *  jsdom-safe. Returns `false` (and does not expand) when the matching item
 *  has been dismissed, so a click always leads somewhere or falls back. */
export function expandWorkToastForQuestion(
  awaitingInputId: string,
  displayId: number | null,
): boolean {
  const store = useWorkToastStore.getState();
  const key = findWorkToastKeyByAwaitingInputId(store.items, awaitingInputId);
  if (!key || store.items[key]?.dismissed) return false;
  const resolvedDisplayId = displayId ?? useActiveDisplay.getState().activeDisplayId;
  store.expand(key, resolvedDisplayId);
  return true;
}
